import { render, staticRenderFns } from "./SimplifiedProposalTable.vue?vue&type=template&id=6814ba35&scoped=true"
import script from "./SimplifiedProposalTable.vue?vue&type=script&lang=js"
export * from "./SimplifiedProposalTable.vue?vue&type=script&lang=js"
import style0 from "./SimplifiedProposalTable.vue?vue&type=style&index=0&id=6814ba35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6814ba35",
  null
  
)

export default component.exports